import React from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import InputText from "../../components/forms/elements/InputText";
import CrudForm from "../../components/forms/custom/CrudForm";
import Util from "../../utils/Util";
import BtnButton from "../../components/forms/elements/BtnButton";
import BtnGroup from "../../components/forms/elements/BtnGroup";
import MostraValor from "../../components/app/MostraValor";
import AcordoService from "../../services/AcordoService";

class FormAcordo extends CrudForm {

    constructor(props) {
        super(props);


        this.state.model = {
            idAcordo : null,
            vlCobranca : 0,
            idProprietario : "",
            idRepresentante : "",
            idOrdemTipo : "",
            flMulta : 0,
            flJuros : 0,
            flVencer : 0,
            acordoCobranca : []
        };

        this.state.crud = {
            service: AcordoService,
            labels: {
                title: 'Acordo',
            },
            urlList: '/LstAcordo',
        };

    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    getStatus(item) {
        if (item.flPago) {
            return <span className="rounded-pill badge w-100 fs-7 text-bg-success"> Pago </span>
        }

        if (item.flVencido) {
            return <span className="rounded-pill badge w-100 fs-7 text-bg-danger"> Vencido </span>
        }

        return <span className="rounded-pill badge w-100 fs-7 text-bg-warning"> Aberto </span>
    }


    getBtns() {
        return (
            <div className="d-grid gap-2 d-md-flex">
                <BtnButton className="btn-outline-secondary" onClick={this.handleClose}> Voltar </BtnButton>
            </div>
        );

    }

    getRenderFields() {
        return (
            <div className="row mb-3 g-3">

                <div className="fw-bold mb-3 border-dark border-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                    </svg> Faturas Selecionadas
                </div>

                {this.state.model.acordoCobranca?.map(item => item.idFatura).filter((value, index, self) => self.indexOf(value) === index).map((idFatura, indexFatura) => (
                    <React.Fragment key={indexFatura}>
                        <div className="table-responsive-lg">
                            <table className="table table-sm table-striped table-bordered caption-top">
                                <thead className="table-light">
                                    <tr>
                                        <th colSpan={12}>
                                           Fatura: {idFatura}
                                        </th>
                                    </tr>
                                    <tr>
                                        <th scope="col" className="text-center">Cobrança</th>
                                        <th scope="col" className="text-center">Parcela</th>
                                        <th scope="col" className="text-center">Status</th>
                                        <th scope="col" className="text-center">Vencimento</th>
                                        <th scope="col" className="text-end">Cobrança</th>
                                        <th scope="col" className="text-end">Pago</th>
                                        <th scope="col" className="text-end">Aberto</th>
                                        <th scope="col" className="text-end">Multa</th>
                                        <th scope="col" className="text-end">Juros</th>                                
                                        <th scope="col" className="text-end">Desconto</th>
                                        <th scope="col" className="text-end">Devido</th>                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.model.acordoCobranca?.filter(i => parseInt(i.idFatura) === parseInt(idFatura))?.map((cobranca, indexCobranca) => (
                                        <React.Fragment key={indexCobranca}>
                                            <tr className="tr-borderless text-start">
                                                <td className="align-middle text-center">
                                                    {cobranca.idCobranca}
                                                </td>
                                                <td className="align-middle text-center">
                                                    {cobranca.nrParcela}
                                                </td>
                                                <td className="align-middle text-center">
                                                    {this.getStatus(cobranca)}
                                                </td>
                                                <td className="align-middle text-center">
                                                    {Util.date2Br(cobranca.dtVencimento)}
                                                </td>
                                                <td className="align-middle text-end text-end text-primary fw-bold">
                                                    <MostraValor>{Util.floatToReais(cobranca.vlCobranca)}</MostraValor>
                                                </td>
                                                <td className="align-middle text-end text-success fw-bold">
                                                    <MostraValor>{Util.floatToReais(cobranca.vlBaixa)}</MostraValor>
                                                </td>
                                                <td className={`align-middle text-end fw-bold ${(cobranca.vlAberto) > 0 ? "text-danger" : ""}`}>
                                                    <MostraValor>{Util.floatToReais(cobranca.vlAberto)}</MostraValor>
                                                </td>
                                                <td className="align-middle text-end text-danger fw-bold">
                                                    <MostraValor>{cobranca.flVencido && !cobranca.flPago ? Util.floatToReais(cobranca.vlMulta) : ""}</MostraValor>
                                                </td>
                                                <td className="align-middle text-end text-danger fw-bold">
                                                <MostraValor>{cobranca.flVencido && !cobranca.flPago ? Util.floatToReais(cobranca.vlJuros) : ""}</MostraValor>
                                                </td>
                                                <td className="align-middle text-end text-danger fw-bold">
                                                    <MostraValor>{Util.floatToReais(cobranca.vlDesconto)}</MostraValor>
                                                </td>
                                                <td className="align-middle text-end text-danger fw-bold">
                                                    <MostraValor>{Util.floatToReais(cobranca.vlDevido)}</MostraValor>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                    
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>
                ))}

                <div className="fw-bold mb-3 border-dark border-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person" viewBox="0 0 16 16">
                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4Zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10Z" />
                    </svg> Dados do Acordo
                </div>

                <div className="row g-3">
                    <InputText className="text-end text-primary fw-bold" label="Valor Cobranças" md={2} value={Util.floatToReais(this.state.model.vlCobranca)} readOnly opcionalLabel={false} />
                    <InputText className="text-end text-success fw-bold" label="Valor Pago" md={2} value={Util.floatToReais(this.state.model?.vlBaixa)} readOnly opcionalLabel={false} />
                    <InputText className="text-end text-danger fw-bold" label="Valor Aberto" md={2} value={Util.floatToReais(this.state.model?.vlAberto)} readOnly opcionalLabel={false} />
                    
                    <InputText className="text-end text-danger fw-bold" label="Valor Multa" md={2} value={Util.floatToReais(this.state.model?.vlMulta)} readOnly opcionalLabel={false} />                
                    <InputText className="text-end text-danger fw-bold" label="Valor Juros" md={2} value={Util.floatToReais(this.state.model?.vlJuros)} readOnly opcionalLabel={false} />                
                    <InputText className="text-end text-danger fw-bold" label="Valor Devido" md={2} value={Util.floatToReais(this.state.model?.vlDevido)} readOnly opcionalLabel={false} />
                    
                    <InputText  label="Representante" md={12} value={this.state.model.nomeRepresentante} readOnly opcionalLabel={false} />
                    <InputText  label="Proprietário" md={12} value={this.state.model.nomeProprietario} readOnly opcionalLabel={false} />
                </div>

                <div className="row mb-1 g-3">
                    <BtnGroup disabled md={3} sizing="sm" className="w-100" name="flMulta" value={this.state.model.flMulta} label="Incluir Multa" options={[{ value: 1, label: 'Sim' }, { value: 0, label: 'Não' }]} onChange={this.handleChange} opcionalLabel={false} />
                    <BtnGroup disabled md={3} sizing="sm" className="w-100" name="flJuros" value={this.state.model.flJuros} label="Incluir Juros" options={[{ value: 1, label: 'Sim' }, { value: 0, label: 'Não' }]} onChange={this.handleChange} opcionalLabel={false} />
                    <BtnGroup disabled md={3} sizing="sm" className="w-100" name="flVencer" value={this.state.model.flVencer} label="Incluir Parcelas a Vencer" options={[{ value: 1, label: 'Sim' }, { value: 0, label: 'Não' }]} onChange={this.handleChange} opcionalLabel={false} />

                    <InputText className="text-end text-danger fw-bold bg-dark" label="Valor Acordo" md={3} value={Util.floatToReais(this.state.model?.vlAcordo)} readOnly opcionalLabel={false} />
                </div>           

            </div>
        );
    }

    render() {
        return super.render();
    }
}

function With(props) {
    let navigate = useNavigate();
    let params = useParams();
    let location = useLocation();
    return <FormAcordo {...props} navigate={navigate} params={params} location={location} />
}

export default With